// extracted by mini-css-extract-plugin
module.exports = {"section":"dialog_section__xpi__"};